import { css } from '@emotion/core';
export var activePanel = {
  name: "odz94x",
  styles: "margin-top:5px;"
};
export var inactiveContents = {
  name: "1hyfx7x",
  styles: "display:none;"
};